module.exports = __webpack_public_path__ + "static/mercy-b6c8c6b1f68c5816b8da26ee39d500ec.png";